$(document).ready(function() {

  if ($('.contact-details').length) {
    checkNumeric();
  }

  function checkNumeric () {
    var checkNumeric;
    var val;
    $('input[type="tel"]').blur(function() {
      val = $(this).val().replace(/ +?/g, '');
      checkNumeric = $.isNumeric(val);

      if (!checkNumeric || val.length < 10) {
        $(this)
          .parent()
          .parent()
          .find('.invalid-feedback')
          .show()
          $(this).removeClass('success').addClass('error');
      } else {
        $(this)
          .parent()
          .parent()
          .find('.invalid-feedback')
          .hide()
          $(this).removeClass('error').addClass('success');
      }
    });
  }
});
